import React from 'react';
import { useResourceContext } from 'react-admin';
import useCheckAccess from 'hooks/useCheckAccess';
import EnumSelectInput from './Enum/EnumSelectInput';

const REVENUE_IMPACTING_TYPES = [
  'credit_transfer',
  'credit_adjustment',
  'wo_recovery',
  'short_pay',
];

const AdjustmentTypesSelect = (props) => {
  const resource = useResourceContext(props);
  const checkAccess = useCheckAccess();

  const hasRevenueImpactingPermission = checkAccess(
    'actions',
    resource || 'RevenueAdjustment',
    'create_with_revenue_impacting_adjustment_type',
  );

  return (
    <EnumSelectInput
      label="Adjustment Type"
      source="adjustment_type"
      filterOut={!hasRevenueImpactingPermission ? REVENUE_IMPACTING_TYPES : undefined}
      {...props}
    />
  );
};

export default AdjustmentTypesSelect;
